import React, { useState, useEffect } from "react";
import "./LoadingPage.css";
import { LineWobble } from "ldrs/react";
import "ldrs/react/LineWobble.css";
import { renderStatementWithKaTeX } from "../../Status";

const LoadingPage = () => {
  /* return (
    <div className="LoadingPage-container">
        
    </div> */

  return (
    <div className="loading-container">
      {/* Floating background symbols */}
      <span className="floating-symbol pi">{renderStatementWithKaTeX("$\\pi$")}</span>
      <span className="floating-symbol sigma">{renderStatementWithKaTeX("$\\sum$")}</span>
      <span className="floating-symbol infinity">{renderStatementWithKaTeX("$\\infty$")}</span>
      <span className="floating-symbol sqrt">{renderStatementWithKaTeX("$\\sqrt{}$")}</span>
      <span className="floating-symbol integral">{renderStatementWithKaTeX("$\\int$")}</span>
      <span className="floating-symbol plusminus">{renderStatementWithKaTeX("$\\pm$")}</span>
      <span className="floating-symbol approx">{renderStatementWithKaTeX("$\\approx$")}</span>
      <h1>Obtaining Data ...</h1>
      <LineWobble
        size="200"
        stroke="5"
        bgOpacity="0.1"
        speed="1.75"
        color="black"
      />
      <p>Don't worry, this won't take a while.</p>
    </div>
  );
};

export default LoadingPage;
